const STRIPE_PUBLISHABLE = process.env.NODE_ENV === 'production'
  ? 'pk_live_4mxodS1urqM170r0EBSO5qG4'
  : 'pk_live_4mxodS1urqM170r0EBSO5qG4';

export default STRIPE_PUBLISHABLE;